import React from 'react';
import API from '../../configAPI';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import CONFIG from '../../config';
import SearchForm from '../partials/SearchForm';
import { PulseLoader } from 'react-spinners';
import {Link} from 'react-router-dom';
import AlphabetFilter from '../partials/AlphabetFilter';


class ProvidersList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            providers: {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
            text_query: '',
            loading: true
        }

    }
    componentDidMount(){
        this.getProviders();
        window.scrollTo(0,0);
    }
    getProviders = () => {
       API.PRODUCTS.get(`providers?page=${this.state.providers.current_page}`)
        .then(resp =>{
            this.setState({
                providers : resp.data,
                loading: !this.state.loading
            });

        })
        .catch(err =>{
            this.setState({
                loading: !this.state.loading
            });
            console.log(err);
        });
    }
    onChangePage = async(page) =>{
       await this.setState({
            providers: {
              ...this.state.providers,
              current_page: page
            },
            loading: !this.state.loading
          });

          this.getProviders();

    }
    searchProviders = (text_search) =>{
        this.setState({
            loading: !this.state.loading
        });
        if(text_search){
            API.PRODUCTS(`providers/search?q=${text_search}`)
            .then(resp =>{
                this.setState({
                    providers : resp.data,
                    loading: !this.state.loading
                });
            })
            .catch(err => {
                console.log(err);
            });
        }else{
            
            this.getProviders();
        }

    }

    filterPerChart =(chart) =>{
        this.setState({
            loading: !this.state.loading
        });
        API.PRODUCTS(`providers/filter?chart=${chart}`)
        .then(resp =>{
            this.setState({
                providers : resp.data,
                loading: !this.state.loading
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }

    

    render(){

        const providerItem = this.state.providers.data.map((prov,index) =>
            <div className="col-xs-12 col-md-3 mt-1 mb-1" key={index}>
                <div className="card full-height">
                    <div className="card-header">
                    {prov.name}
                    </div>
                    <div className="card-body text-center d-flex flex-column justify-content-between">
                    <div className="p-4">
                        <Link to={`/empresa/${prov.slug}`}>
                            <img src={prov.url_logo} className="img-fluid" alt={prov.name}/>
                        </Link>
                    </div>
                    <Link to={`/empresa/${prov.slug}`} className="btn btn-secondary btn-sm">{prov.products_count} Productos disponibles</Link>
                    </div>
                </div>
            </div>
        );


        return(
            
            <div className="container-fluid mt-3 mb-3">
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row mb-2">
                        <div className="col-12">
                            <h4>Empresas</h4>
                        </div>
                        <div className="col-12">
                            <AlphabetFilter onFilter={this.filterPerChart}/>
                        </div>
                        <div className="col-12">
                            <SearchForm submitForm={this.searchProviders} placeHolder="Haz una busqueda en la lista de empresas"/>
                        </div>
                        

                        <div className="col-12">
                            { this.state.providers.last_page > 1 &&
                                <div className="row d-flex justify-content-center">
                                    <Pagination 
                                        className="ant-pagination" 
                                        onChange={this.onChangePage}
                                        current={this.state.providers.current_page}
                                        total={this.state.providers.total}
                                        showTitle={false}
                                        defaultPageSize={this.state.providers.to}
                                    />
                                </div>
                            }
                            <div className="row mt-3 mb-3">
                                {this.state.providers.data.length > 0 ? providerItem : 'Sin resultados'}
                            </div>

                            { this.state.providers.last_page > 1 &&
                                <div className="row d-flex justify-content-center">
                                    <Pagination 
                                        className="ant-pagination" 
                                        onChange={this.onChangePage}
                                        current={this.state.providers.current_page}
                                        total={this.state.providers.total}
                                        showTitle={false}
                                        defaultPageSize={this.state.providers.to}
                                    />
                                </div>
                            }
                        </div>
                    </div>      
                </div>
            </div>
        )
    }
}
export default ProvidersList;